import { Atom } from 'AppReact';
import styled, { css } from "styled-components";
import device from 'components/atoms/utils/device';

const template = styled.button`
  ${({ theme }) => css`
    font-weight: 400;
    font-size: 11px;
    line-height: 19px;
    color: ${`${theme?.colour?.secondary}4D`};
    cursor: pointer;

    @media ${device.tablet} {
      font-weight: 600;
      font-size: 16px;
    }
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template })